module.exports = __webpack_public_path__ + "static/media/CC1.2cdc8a53.png";